export default {
    url: 'members-power-deals',
    include: ['us', 'ca'],
};
